import React from "react";
import { Typography } from "@mui/material";

/**
 * A component that displays a platform icon with a label
 */
const PlatformIcon = ({ icon, label }) => {
  return (
    <div
      className="platform-icon-container"
      style={{
        background: "rgba(15, 15, 15, 0.85)",
        borderRadius: "16px",
        border: "1px solid rgba(255, 255, 255, 0.15)",
        padding: "40px 20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "200px",
        height: "200px",
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.1)",
      }}
    >
      <img
        src={icon}
        alt={label}
        className="platform-icon-image"
        style={{
          filter: "brightness(0) invert(1)",
          width: "80px",
          height: "80px",
          marginBottom: "16px",
        }}
      />
      <Typography
        variant="h6"
        className="platform-icon-label"
        sx={{
          color: "#ffffff",
          fontSize: "1rem",
          fontWeight: 500,
        }}
      >
        {label}
      </Typography>
    </div>
  );
};

export default PlatformIcon;
